import { useEffect, useState } from "react";

/**
 * The current time, re-read every second while `active` — for a countdown that has to move on screen and
 * release what it holds when it ends (within the second). Idle when inactive, so a closed dialog costs no
 * timer.
 */
export function useNow(active: boolean): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, [active]);
  return now;
}
